<template>
    <v-container transparent>
        <v-layout>
            <v-card width="100%" flat>
                <v-container class="py-3">
                    <v-flex offset-lg2 offset-md3 lg8 md6 xs12 align-center justify-space-between>
                        <v-card-title primary-title class="py-4 title">
                            Скачать файлы с результатами исследования {{ this.testId }}
                        </v-card-title>

                        <v-layout v-if="!utility.isLoaded" pa-5>
                            <v-flex xs12>
                                Подождите, идет запрос данных...
                            </v-flex>
                        </v-layout>
                        <v-layout wrap v-if="utility.isLoaded">
                            <v-flex xs12>

                                <p>На данной странице представлены исходные исследования. Ваш геном не
                                    изменяется в течение всей жизни человека, поэтому мы рекомендуем
                                    сохранить полученные данные на отдельный накопитель.</p>
                                <p>Внимание - некоторые файлы имеют очень большой объем. Может потребоваться много
                                    времени, и при использовании мобильного интернета, оператор может
                                    взимать дополнительную плату.</p>

                                <h2 style="text-align: center;margin: 30px 0 15px 0">Результат генетического
                                    исследования</h2>

                                <div style="font-size: 1.2em">
                                    Тип исследования: <b>{{fileData.analtype_long}}</b><br>
                                    Тип пробоподготовки: <b>{{fileData.protocol_lib}}</b><br>
                                    Тип прибора: <b>{{fileData.protocol_device}}</b><br>
                                    Дата получения данных: <b>{{fileData.analysis_date_recieved}}</b><br>
                                    <div v-if="fileData.analtype_is_panel===0">
                                        Покрытие (реальное / ожидаемое): <b>{{fileData.qc_off_cov_med}}x/{{fileData.protocol_off_cov}}x</b>
                                    </div>
                                    <div v-if="fileData.analtype_is_panel===1">
                                        Покрытие (реальное / ожидаемое): <b>{{fileData.qc_on_cov_med}}x/{{fileData.protocol_on_cov}}x</b><br>
                                    </div>
                                    <div v-if="fileData.analtype_is_panel===2">
                                        Покрытие экзома (реальное / ожидаемое): <b>{{fileData.qc_on_cov_med}}x/{{fileData.protocol_on_cov}}x</b><br>
                                        Покрытие генома (реальное / ожидаемое): <b>{{fileData.qc_off_cov_med}}x/{{fileData.protocol_off_cov}}x</b>
                                    </div>
                                    Доля ДНК человека: <b>{{fileData.qc_reference_perc}}%</b><br>

                                </div>

                                <div style="font-size: 1.2em; margin-top: 20px">
                                    <div v-if="fileData.allow_fastq===11">
                                        FASTQ: прямые
                                        (<a :href="`https://storage.zenome.io/download.php?hkey=${testCodeSHA}&proto=${fileData.protocol_id}&type=fastqR1`"
                                           target="_blank"><b>{{testIdPrefix}}{{testId}}_{{testType}}_R1.fastq.gz</b></a>)
                                        <template v-if="fileData.reads_single===0"> и обратные (<a :href="`https://storage.zenome.io/download.php?hkey=${testCodeSHA}&proto=${fileData.protocol_id}&type=fastqR2`"
                                               target="_blank"><b>{{testIdPrefix}}{{testId}}_{{testType}}_R2.fastq.gz</b></a>)
                                        </template>
                                        прочтения

                                    </div>
                                    <div v-if="fileData.allow_gvcf===1">
                                        gVCF (список проанализированных состояний):
                                        <a :href="`https://storage.zenome.io/download.php?hkey=${testCodeSHA}&proto=${fileData.protocol_id}&type=gvcf`"
                                           target="_blank"><b>{{testIdPrefix}}{{testId}}_{{testType}}.gvcf.gz</b></a>
                                    </div>
                                    <div v-if="fileData.allow_gvcf===1">
                                        VCF (список отличий от референса, HG19):
                                        <a :href="`https://storage.zenome.io/download.php?hkey=${testCodeSHA}&proto=${fileData.protocol_id}&type=vcf`"
                                           target="_blank"><b>{{testIdPrefix}}{{testId}}_{{testType}}.vcf.gz</b></a>
                                    </div>
                                    <div v-if="fileData.allow_23me===1">
                                        23me:
                                        <a :href="`https://storage.zenome.io/download.php?hkey=${testCodeSHA}&proto=${fileData.protocol_id}&type=23me`"
                                           target="_blank"><b>{{testIdPrefix}}{{testId}}_{{testType}}.23me.gz</b></a>
                                    </div>
                                </div>
                                <div style="font-size: 1.2em; margin-top: 20px">
                                    Готовность данных:  <b>{{fileData.analysis_status_name}}</b>
                                </div>
                            </v-flex>

                        </v-layout>
                    </v-flex>
                </v-container>
            </v-card>
        </v-layout>
    </v-container>
</template>

<script>
    import sha256 from "js-sha256"

    export default {
        name: "TestFileDownload",
        props: ['testId'],
        data: () => ({
            testIdPrefix: "ZN",
            testType: "wgs",
            testCodeSHA: "",
            utility: {
                isLoaded: false
            },
        }),
        watch: {},
        methods: {
            downloadFile: function () {
            },
        },
        computed: {}
        ,
        created: function () {
            const this_ = this
            this.$store.state.user.testcodes.forEach((testcode) => {
                if (testcode.id === this_.testId) {
                    this_.testCodeSHA = testcode.id + (sha256(testcode.testcode.slice(0, 6))).slice(0, 10)
                }
            })


            this.$store.dispatch('gettestfiledata', {testCode: this.testId}).then(function (response) {
                this_.response = response
                if (this_.response.status != 200) {
                    this_.$store.dispatch('processError', this_.response)
                }
                if (this_.response.status === 200) {
                    this_.utility.isLoaded = true
                    this_.fileData = this_.response.data.testFileData
                    this_.testType = this_.fileData.analtype_short
                }
            })
        }

    }
</script>

<style type="scss" scoped>
    .v-text-field-email {
        input {
            color: red;
        }
    }
</style>
